import {RootDynamicComponentHelper} from "@shared/helpers/root-dynamic-component-helper";
import {TaxSitesComponent} from '@features/tax-sites/components/tax-sites/tax-sites.component';

// @dynamic
export class TaxSitesDynamicComponentHelper {
  static components: any;

  static create(): void {
  }
  public static init () {
    if (TaxSitesDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['TaxSitesComponent'] = TaxSitesComponent;
    TaxSitesDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    TaxSitesDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
